import { Card, ConfigProvider, Flex, Typography } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useGetRefusalPicturesData } from 'business/quality-control/pages/segment-history/components/segment-details-drawer/hooks/data/get-refusal-pictures';
import { SegmentHistory } from 'business/quality-control/pages/segment-history/hooks/data/types';
import { formatDateWithMiddleDot } from 'technical/format/date';
import { Picture, PicturesList } from 'ui/pictures';

import styles from './index.module.scss';

export const RejectionDetails = ({
  historyEntry,
}: {
  historyEntry: SegmentHistory['history'][number];
}) => {
  const { t } = useTranslation();

  const { data: refusalPicturesData, isLoading } = useGetRefusalPicturesData(
    historyEntry.segmentRefusal?.id,
  );
  const refusalPictures: Picture[] = refusalPicturesData
    ? refusalPicturesData.pictures.map((item) => ({
        description: item.id,
        path: item.path,
      }))
    : [];

  return (
    <Card className={styles.card} variant="borderless">
      <Flex gap={16} vertical>
        <Flex justify="space-between">
          <div>
            <ConfigProvider
              theme={{
                components: {
                  Typography: {
                    titleMarginBottom: 0,
                  },
                },
              }}
            >
              <Typography.Title level={5} className={styles.entryTitle}>
                {t('qualityControl.segmentHistory.drawer.details.title', {
                  context: 'rejection',
                })}
              </Typography.Title>
            </ConfigProvider>

            <span className={styles.detailLabel}>
              {formatDateWithMiddleDot(historyEntry.segmentRefusal?.createdAt)}
            </span>
          </div>
        </Flex>

        <div>
          <Flex vertical>
            <span className={styles.detailLabel}>
              {t('qualityControl.segmentHistory.drawer.details.comment')}
            </span>
            <span className={styles.detailValue}>
              {historyEntry.segmentRefusal?.description || '-'}
            </span>
          </Flex>
        </div>

        <PicturesList pictures={refusalPictures} isLoading={isLoading} />
      </Flex>
    </Card>
  );
};
